import React from "react";
import "./AnyMore.css";
import {getProducts, hideAnyMore} from "../extras/Actions";
export default class AnyMore extends  React.Component{
    componentDidMount() {
        getProducts()
    }

    render() {
        return (
            <div className="any-more-container">
                <button className="close" onClick={hideAnyMore}>
                    X
                </button>
                <div className="elements-container">
                    <h3>¿DESEAS AGREGAR ALGO MÁS?</h3>
                    <h6>Desliza para ver mas</h6>
                    <div className="gifts-container">

                    </div>
                    <a href="/payment">
                        PROCEDER AL PAGO
                    </a>
                </div>
            </div>
        );
    }
}